<template>
  <footer id="main-footer">
    <svg xmlns="http://www.w3.org/2000/svg" style="display:none;">
      <symbol id="twitter" viewBox="0 0 49.221 40">
        <path d="M49.22,4.734c-1.809,0.804-3.756,1.346-5.799,1.589c2.086-1.249,3.686-3.228,4.439-5.587
        c-1.951,1.158-4.111,1.998-6.412,2.452C39.605,1.227,36.982,0,34.077,0c-5.576,0-10.098,4.521-10.098,10.099
        c0,0.791,0.089,1.562,0.262,2.302C15.848,11.978,8.407,7.958,3.427,1.848C2.557,3.339,2.06,5.074,2.06,6.926
        c0,3.504,1.782,6.595,4.492,8.405c-1.654-0.053-3.212-0.508-4.573-1.264c-0.001,0.041-0.001,0.084-0.001,0.127
        c0,4.893,3.48,8.973,8.1,9.903c-0.847,0.229-1.739,0.354-2.66,0.354c-0.651,0-1.284-0.062-1.9-0.182
        c1.285,4.012,5.015,6.934,9.433,7.014c-3.456,2.709-7.809,4.322-12.541,4.322c-0.814,0-1.618-0.049-2.408-0.143
        C4.47,38.33,9.778,40,15.48,40c18.576,0,28.732-15.387,28.732-28.731c0-0.438-0.01-0.873-0.029-1.308
        C46.156,8.539,47.866,6.759,49.22,4.734z"></path>
      </symbol>
      <symbol id="facebook" viewBox="18.891 10.326 18.586 40">
        <path d="M37.477,23.278h-6.33v-4.151c0-1.56,1.033-1.923,1.762-1.923c0.727,0,4.467,0,4.467,0v-6.854l-6.152-0.023
        c-6.829,0-8.383,5.112-8.383,8.383v4.569h-3.949v7.062h3.949c0,9.063,0,19.985,0,19.985h8.307c0,0,0-11.029,0-19.985h5.605
        L37.477,23.278z"></path>
      </symbol>
      <symbol id="instagram" viewBox="0 0 40 40">
        <path d="M20 9.597c-5.646 0-10.323 4.596-10.323 10.323 0 5.726 4.597 10.322 10.323 10.322s10.322-4.677 10.322-10.322-4.678-10.323-10.322-10.323zm0 16.935c-3.629 0-6.613-2.982-6.613-6.612 0-3.629 2.984-6.613 6.613-6.613s6.613 2.984 6.613 6.613c0 3.63-2.984 6.612-6.613 6.612z"/><circle cx="30.726" cy="9.355" r="2.339"/><path d="M36.773 3.306c-2.095-2.177-5.081-3.306-8.466-3.306h-16.615c-7.014 0-11.692 4.678-11.692 11.693v16.532c0 3.469 1.129 6.451 3.387 8.63 2.176 2.097 5.081 3.145 8.386 3.145h16.451c3.468 0 6.371-1.128 8.468-3.145 2.179-2.096 3.308-5.081 3.308-8.549v-16.613c0-3.387-1.129-6.29-3.227-8.387zm-.484 25c0 2.502-.726 4.518-2.178 5.889-1.451 1.371-3.467 2.096-5.887 2.096h-16.451c-2.419 0-4.436-.725-5.887-2.096-1.452-1.452-2.177-3.469-2.177-5.969v-16.533c0-2.419.726-4.436 2.177-5.887 1.371-1.371 3.468-2.097 5.887-2.097h16.612c2.42 0 4.437.726 5.888 2.177 1.371 1.452 2.178 3.468 2.178 5.806v16.613h-.162v.001z"/>
      </symbol>
    </svg>
    <div class="hwm-section-wrapper">
      <p class="slogan h2" v-html="slogan[appLang]"></p>
      <ul class="footer-social-media">
        <li><a class="facebook" :href="facebookLink[appLang]"><svg class="icon facebook"><use xlink:href="#facebook" /></svg>Facebook</a></li>
        <li><a class="twitter" :href="twitterLink[appLang]"><svg class="icon twitter"><use xlink:href="#twitter" /></svg>Twitter</a></li>
        <li><a class="instagram" :href="instagramLink[appLang]"><svg class="icon instagram"><use xlink:href="#instagram" /></svg>Instagram</a></li>
      </ul>
      <footer>
        <img class="canada-wordmark" src="https://www.warmuseum.ca/wp-content/themes/hwm-2015/_images/canada-wordmark.svg" width="100" height="24" alt="Symbol of the Government of Canada" />
        <div class="outro">
          <p class="copyright-text" v-html="copyrightText[appLang]"></p>
          <ul class="disclaimer-list">
            <li v-for="(link, index) in disclaimerLinks[appLang]" :key="index">
              <a :href="link.url">{{ link.text }}</a>
            </li>
          </ul>
        </div>
      </footer>
    </div><!--End .hwm-section-wrapper-->
    <!-- !! Corresponding styles bootstrapped and added to nuxt.config.js file. -->
  </footer><!--End #main-footer-->
</template>
<script>
export default {
  methods: {},
  computed: {
    appLang() {
      return this.$store.getters.getAppLang;
    }
  },
  created() {
    // console.log('this.getAppLang()', this.getAppLang());
  },
  data() {
    return {
      slogan: {
        en: 'Your Country.<br /> Your History.<br /> Your Museum.',
        fr: 'Votre pays.<br /> Votre histoire.<br /> Votre musée.'
      },
      copyrightText: {
        en: '© Canadian War Museum',
        fr: '© Musée canadien de la guerre'
      },
      facebookLink: {
        en: 'http://www.facebook.com/warmuseum',
        fr: 'https://www.facebook.com/museedelaguerre'
      },
      twitterLink: {
        en: 'http://twitter.com/CanWarMuseum',
        fr: 'https://twitter.com/MusCanGuerre'
      },
      instagramLink: {
        en: 'https://www.instagram.com/canwarmuseum',
        fr: 'https://www.instagram.com/muscanguerre'
      },
      disclaimerLinks: {
        en: [
          { url: 'https://www.warmuseum.ca/about/privacy-statement/', text: 'Privacy Notice' },
          { url: 'https://www.warmuseum.ca/about/copyright-and-permissions/', text: 'Copyright' }
        ],
        fr: [
          { url: 'https://www.museedelaguerre.ca/a-propos/protection-des-renseignements-personnels/', text: 'Protection des renseignements personnels' },
          { url: 'https://www.museedelaguerre.ca/a-propos/droits-dauteur-et-permissions/', text: 'Droits d’auteur' }
        ]
      }
    };
  }
};
</script>
<!-- *** -->
<style lang="css">
  /* Base styles */
  @import 'https://www.warmuseum.ca/wp-content/themes/hwm-2015/_css/footer.css';
</style>
<style lang="scss">
  // App specific styles (normalize, overrides, etc).
  @import '@/assets/scss/legacy.footer15.scss';
</style>